import { GET_COUPON_BY_NAME } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { authenticationTypes } from 'root/src/shared/constants/auth'

import { recordEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'
import { coupon } from 'root/src/shared/descriptions/endpoints/recordTypes'

import getCouponPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/getCouponPayloadSchema'
import addCouponResponseSchema from 'root/src/shared/descriptions/endpoints/schemas/addCouponResponseSchema'

export const payloadSchema = getCouponPayloadSchema
export const responseSchema = addCouponResponseSchema

export default {
	[GET_COUPON_BY_NAME]: {
		authentication: authenticationTypes.authenticated,
		endpointType: recordEndpointType,
		recordType: coupon,
		payloadSchema,
		responseSchema,
	},
}
